// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1j4Co","detailsBorder":"styles_detailsBorder__3bTSM"};